import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom'

import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

// import shoppingImage from '../../assets_user/img/shopping-cart.png';
// import orderImage from '../../assets_user/img/order-image.png';
// import heartImage from '../../assets_user/img/love-image.png'

import { useBlogContext } from '../../../fetchdata/BlogContext';
import { Helmet } from 'react-helmet';
import getCookie from '../../../helper/getCookie';
import getDecryptData from '../../../helper/getDecryptData';
import eraseCookie from '../../../helper/eraseCookie';
import HeaderPage from '../../components/HeaderPage';
import NavBar from '../../components/NavBar';

const Account = () => {

  const decryptdatajson = getDecryptData();


  const isLoginFromLocalStorage = getCookie('token') ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //logout
  const handleLogout = () => {
    try {
      dispatch(authActions.logout());
      toast.success("Logout Successfully");
      // localStorage.clear();
      eraseCookie('token')
      setIsLogin(false);
    } catch (error) {
      console.log(error);
    }
  };

  const isActive = (path) => {
    return window.location.pathname === path ? 'active' : '';
  };


  return (
    <>

      <HeaderPage title={'My Profile'} />
      <main className="page-content  mypadding overflow-auto pb-4 px-0" >

        <div className='px-3'>

          {isLogin ? (
            <div className="dz-list bg-transparent px-0 px-2 style-3">
              <ul className="mb-3 px-0">

                {decryptdatajson && decryptdatajson.type !== 1 ?
                  <li>
                    <Link className="item-content item-link" to="/account/all-order">
                      <div className="dz-icon icon-xs icon-fill">
                        <i className="fas fa-box-open"></i>
                      </div>
                      <div className="dz-inner">
                        <span className="title text-gold">My Order</span>
                        <div className="link-desc">Manage all my Orders</div>
                      </div>
                    </Link>
                  </li> :
                  <>
                    <li>
                      <Link className="item-content item-link" to="/all-order">
                        <div className="dz-icon icon-xs icon-fill">
                          <i className="fas fa-box-open"></i>
                        </div>
                        <div className="dz-inner">
                          <span className="title text-gold">All Order</span>
                          <div className="link-desc">Manage all my Orders</div>
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link className="item-content item-link" to="/pending-order">
                        <div className="dz-icon icon-xs icon-fill">
                          <i className="fas fa-box-open"></i>
                        </div>
                        <div className="dz-inner">
                          <span className="title text-gold">Pending Order</span>
                          <div className="link-desc">Manage all my Orders</div>
                        </div>
                      </Link>
                    </li>

                    <li>
                      <Link className="item-content item-link" to="/complete-order">
                        <div className="dz-icon icon-xs icon-fill">
                          <i className="fas fa-box-open"></i>
                        </div>
                        <div className="dz-inner">
                          <span className="title text-gold">Complete Order</span>
                          <div className="link-desc">Manage all my Orders</div>
                        </div>
                      </Link>
                    </li>

                    <li>
                      <Link className="item-content item-link" to="/cancel-order">
                        <div className="dz-icon icon-xs icon-fill">
                          <i className="fas fa-box-open"></i>
                        </div>
                        <div className="dz-inner">
                          <span className="title text-gold">Cancel Order</span>
                          <div className="link-desc">Manage all my Orders</div>
                        </div>
                      </Link>
                    </li>



                  </>}
                {/* My Order */}


                {/* My Profile */}
                <li>
                  <Link className="item-content item-link" to="/account/profile">
                    <div className="dz-icon icon-xs icon-fill">
                      <i className="far fa-address-book"></i>
                    </div>
                    <div className="dz-inner">
                      <span className="title text-gold">My Profile</span>
                      <div className="link-desc">Change your profile details</div>
                    </div>
                  </Link>
                </li>

                {/* Wishlist */}
                <li>
                  <Link className="item-content item-link" to="/wishlist">
                    <div className="dz-icon icon-xs icon-fill">
                      <i className="ri-heart-line"></i>
                    </div>
                    <div className="dz-inner">
                      <span className="title text-gold">Wishlist</span>
                      <div className="link-desc">View your saved products</div>
                    </div>
                  </Link>
                </li>


                {/* Change Password */}
                <li>
                  <Link className="item-content item-link" to="/account/password">
                    <div className="dz-icon icon-xs icon-fill">
                      <i className="far fa-user"></i>
                    </div>
                    <div className="dz-inner">
                      <span className="title text-gold">Change Password</span>
                      <div className="link-desc">Change your profile password</div>
                    </div>
                  </Link>
                </li>


                {/* Help & Support */}
                <li>
                  <Link className="item-content item-link" to="/account/support">
                    <div className="dz-icon icon-xs icon-fill">
                      <i className="fas fa-headset"></i>
                    </div>
                    <div className="dz-inner">
                      <span className="title text-gold">Help &amp; Support</span>
                      <div className="link-desc">Contact Us for help and support</div>
                    </div>
                  </Link>
                </li>

                {/* Ring Size */}
                <li>
                  <Link className="item-content item-link" to="/ring-size">
                    <div className="dz-icon icon-xs icon-fill">
                      <i className="fas fa-ring"></i>
                    </div>
                    <div className="dz-inner">
                      <span className="title text-gold">Ring Size Checker</span>
                      <div className="link-desc">Measure your ring size easily</div>
                    </div>
                  </Link>
                </li>


                {/* Logout */}
                <li>
                  <Link
                    onClick={handleLogout}
                    className="item-content item-link"
                    to="#"
                  >
                    <div className="dz-icon icon-xs icon-fill">
                      <i className="fas fa-sign-out-alt"></i>
                    </div>
                    <div className="dz-inner">
                      <span className="title text-gold">Logout</span>
                      <div className="link-desc">Logout your account</div>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
          ) : (
            <div className="dz-list bg-transparent px-0 style-3">
              <ul className="mb-3 px-0">

                {/* Help & Support */}
                <li>
                  <Link className="item-content item-link" to="/account/support">
                    <div className="dz-icon icon-xs icon-fill">
                      <i className="fas fa-headset"></i>
                    </div>
                    <div className="dz-inner">
                      <span className="title text-gold">Help &amp; Support</span>
                      <div className="link-desc">Contact Us for help and support</div>
                    </div>
                  </Link>
                </li>

                {/* Logout */}
                <li>
                  <Link
                    className="item-content item-link"
                    to="/login"
                  >
                    <div className="dz-icon icon-xs icon-fill">
                      <i className="fas fa-sign-in-alt"></i>
                    </div>
                    <div className="dz-inner">
                      <span className="title text-gold">Login</span>
                      <div className="link-desc">Login your account</div>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
          )}
        </div>
        <NavBar />
      </main>

    </>
  )
}

export default Account